import request from '@/utils/request'
/**
 * 获取用户个人信息
 */
export function personalMessage(query) {
  return request({
    url: 'user/catinfo/',
    method: 'get',
    params: query
  })
}
/**
 * 获取用户今年与今日各类型文限量
 */
 export function wenNumber(query) {
    return request({
      url: 'user/new_sortcount/',
      method: 'get',
      params: query
    })
  }
  /**
 * 查看个人用户消息已读、未读的内容
 */
 export function information(query) {
    return request({
      url: 'user/hadreads/',
      method: 'get',
      params: query
    })
  }
  /**
 * 获取近3天的系统消息
 */
 export function threeDay(query) {
  return request({
    url: 'user/systeminfo/',
    method: 'get',
    params: query
  })
}

 /**
 * 获取用户系统消息
 */
  export function fetchMessage(query) {
    return request({
      url: 'user/system_msg/',
      method: 'get',
      params: query
    })
  }

/**
 * 系统消息已读
 */
 export function readMessage(data) {
  return request({
    url: 'user/system_msg/',
    method: 'post',
    data
  })
}

/**
 * 消息列表（新消息中心）
 */
export function messageList(query) {
  return request({
    url: 'message/list/',
    method: 'get',
    params: query
  })
}

/**
 * 消息未读数量
 */
export function messageUnread(query) {
  return request({
    url: 'message/unread/',
    method: 'get',
    params: query
  })
}

/**
 * 消息详情
 */
export function messageDetail(query) {
  return request({
    url: 'message/detail/',
    method: 'get',
    params: query
  })
}

/**
 * 单条消息已读
 * body: { msg_ids: id }
 */
export function messageRead(data) {
  return request({
    url: 'message/read/',
    method: 'post',
    data
  })
}

/**
 * 消息一键已读
 */
export function messageReadAll(data) {
  return request({
    url: 'message/read_all/',
    method: 'post',
    data
  })
}

/**
 * 删除消息（若后端路径不同可再调整）
 * body: { msg_ids: id }
 */
export function messageDelete(data) {
  return request({
    url: 'message/delete/',
    method: 'post',
    data
  })
}

 /**
 * 注册获取手机号验证码
 */
 export function phoneRegister(query) {
  return request({
    url: 'user/phoneregister/',
    method: 'get',
    params: query
  })
}

 /**
 * 检索用户所在机构院系
 */
 export function serachDepartment(query) {
  return request({
    url: 'user/serach_department/',
    method: 'get',
    params: query
  })
}
/**
 * 完善用户信息
 */
export function userComplete(data) {
  return request({
    url: 'user/Complete_user_information/',
    method: 'post',
    data
  })
}

 /**
 * 修改邮箱地址-获取邮箱验证码
 */
 export function emailRegister(query) {
  return request({
    url: 'user/editemail/',
    method: 'get',
    params: query
  })
}

/**
 * 修改手机号-发送验证码
 */
export function modifyUserSendCode(query) {
  return request({
    url: 'user/modify_user/',
    method: 'get',
    params: query
  })
}

/**
 * 修改手机号/邮箱-提交
 */
export function modifyUser(data) {
  return request({
    url: 'user/modify_user/',
    method: 'post',
    data
  })
}

/**
 * 获取用户所在机构院系列表
 */
export function userorganInfo(query) {
  return request({
    url: 'user/userorgan_info',
    method: 'get',
    params: query
  })
}

 /**
 * 生成小程序码
 */
 export function appletWx(query) {
  return request({
    url: 'user/Wx_applet_code/',
    method: 'get',
    params: query
  })
}


 /**
 * 
 */
 export function xnUseraAes(query) {
  return request({
    url: 'user/xn_user_aes/',
    method: 'get',
    params: query
  })
}
// 中文书套书列表
export function fullSetZhBook(query) {
  return request({
    url: 'user/full-set-zhBook/',
    method: 'get',
    params: query
  })
}

//相似推荐列表
export function similarRecommend(query) {
  return request({
    url: 'user/similar-recommend/',
    method: 'get',
    params: query
  })
}

//完善认证好礼
export function permissionUser(query) {
  return request({
    url: 'user/user_permission/',
    method: 'get',
    params: query
  })
}


// 验证用户是否存在
export function checkUserExist(query) {
  return request({
    url: 'user/check_user_exist/',
    method: 'get',
    params: query
  })
}
/**
 * 创建单点登录用户
 */
export function userCreate(data) {
  return request({
    url: 'user/create_user/',
    method: 'post',
    data
  })
}